import largestRemainder from "src/util/numbers/largestRemainder";

/**
 * Função que formata os dados dos resultados percentuais para 1 casa decimal
 * @param data dados do gráfico evolutivo
 * @param percentage porcentagem a qual a soma de todas as outrasa devem totalizar
 */
export function formatEvolutiveCrossData(data = [], percentage = 100) {
  if (data === null) {
    return;
  }
  return data.map((atual) => {
    /**
     * caso a pesquisa possua dados previstos a soma pode não resultar 100%,
     * então não aplicamos o largest remainder aqui, apenas um arredondamento simples
     */
    const resultadosArredondados = atual.resultados.map((resultado) => ({
      ...resultado,
      resultadoPercentual: Math.round(resultado.resultadoPercentual),
    }));

    return {
      ...atual,
      resultados: resultadosArredondados,
    };
  });
}